// extracted by mini-css-extract-plugin
export default {"mainHeaderBarContainer":"MainHeaderBar_mainHeaderBarContainer__qq593","logo":"MainHeaderBar_logo__hqdx0","user":"MainHeaderBar_user__tIDxN"};